"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATEONLY = void 0;
exports.DATEONLY = {
    alias: 'SOMENTE_DATA',
    description: 'Remove o horário de uma data',
    arg_names: ['data'],
    args_description: ['data para remover o horário'],
    target_date_format: 'dd/MM/yyyy',
    source_date_format: 'yyyy-MM-dd',
};
